import doc                     from '@widesk-core/decorators/doc';
import model                   from '@widesk-core/decorators/model';
import AccountServiceModel     from '@/models/AccountServiceModel';
import TimestampAble           from '@widesk-core/models/traits/TimestampAble';
import Blamable                from '@/models/traits/Blamable';
import SubscriptionModel       from '@models/account/SubscriptionModel';
import SubscriptionPeriodModel from '@models/account/SubscriptionPeriodModel';

@model.urnResource('subscription_price')
@doc.path('/subscription_prices/{?id}')
export default class SubscriptionPriceModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'id': id;
		'subscription': id;
		'subscriptionPeriod': id;
	};

	private declare _tsSorts: {
		'amountExcludingVat': string;
		'id': string;
		'subscription.label': string;
	};

	@doc.number declare amountExcludingVat: number;
	@doc.string declare currency: string;
	@doc.string declare paymentProviderPriceId: string;
	@doc.model(SubscriptionModel) declare subscription: SubscriptionModel;
	@doc.model(SubscriptionPeriodModel) declare subscriptionPeriod: SubscriptionPeriodModel;
}
